

module.exports = __webpack_require__.stylable.create(
    "DropdownBase2729016006",
    {"classes":{"root":"DropdownBase2729016006__root","popoverContent":"Popover2693513086__popoverContent","list":"DropdownBase2729016006__list"},"vars":{},"stVars":{},"keyframes":{}},
    ".DropdownBase2729016006__root .Popover2693513086__popoverContent{overflow:hidden;min-width:192px;width:100%}.DropdownBase2729016006__root.DropdownBase2729016006--withWidth .Popover2693513086__popoverContent{min-width:inherit;width:inherit}.DropdownBase2729016006__root.DropdownBase2729016006--withArrow .Popover2693513086__popover[data-placement*=top] .Popover2693513086__popoverContent,.DropdownBase2729016006__root.DropdownBase2729016006--withArrow .Popover2693513086__popover[data-placement*=bottom] .Popover2693513086__popoverContent{padding:10px 0}",
    7,
    "DropdownBase2729016006",
    __webpack_require__.stylable.$
);
